import {
  Box,
  BoxContent,
  BoxSidebar,
  BoxSidebarItem,
  Heading,
} from '@mm/components';
import { LeadAssignment } from '@mm/state/interfaces/leadAssignments';
import {
  FollowUpModel,
  FollowUpStateType,
  QqFollowUpModel,
} from '@mm/state/model/FollowUpModel';
import classNames from 'classnames';
import { isEmpty as empty } from 'lodash';
import React from 'react';
import { getDeviceInfo, getResolutionInfo } from '@mm/hooks';
import { PrimarySelectWithPush } from '../../../../../common/components/PrimarySelect/PrimarySelectWithPush/PrimarySelectWithPush';
import { SIDEBAR_MENU } from '../../../../../layout/BotBuilderSidebar/sidebar-menu';
import './AutomationRules.pcss';
import { AutomationRulesFilterByKind } from './AutomationRulesFilterByKind/AutomationRulesFilterByKind';
import { BusinessHours } from './BusinessHours/BusinessHours';
import { FollowUps } from './FollowUps/FollowUps';
import { LeadAssignments } from './LeadAssignments/LeadAssignments';
import { SystemMessages } from './SystemMessages/SystemMessages';
import { useFetchAutomationRules } from './use-fetch-automation-rules';
import PrimarySelect from '../../../../../common/components/PrimarySelect/PrimarySelect';
import { useContextSelector } from 'use-context-selector';
import { LiveChatContext } from '../../../liveChat/LiveChatContext';

type Props = {
  className?: string;
};

export const AutomationRules = ({ className }: Props) => {
  const { setFilterKind, activeKind, records } = useFetchAutomationRules();
  const isEmpty = empty(records);

  const lcService = useContextSelector(
    LiveChatContext,
    v => v.lcServiceRef?.current,
  );

  const { isMobile } = getDeviceInfo();
  const { screenWidth } = getResolutionInfo();
  const menuOptions = SIDEBAR_MENU.filter(menu => menu.id === 'CHATBOT')[0]
    ?.menuItems;

  return (
    <>
      {isMobile && screenWidth <= 600 && (
        <PrimarySelectWithPush
          css={{ select: 'automation-rules__primary-select-with-push' }}
          options={menuOptions}
          value={menuOptions[3]}
          headerText="Automation Rules"
          customDropdownStyles={{ zIndex: '99' }}
        />
      )}
      <section className={classNames(className, 'automation-rules')}>
        <Box className="automation-rules__box">
          <BoxSidebar className="automation-rules__box-sidebar">
            <BoxSidebarItem>
              <Heading
                className="automation-rules__filter-heading"
                text="Automation Type"
                size={5}
              />
              <AutomationRulesFilterByKind
                activeKind={activeKind}
                onChange={setFilterKind}
              />
            </BoxSidebarItem>
          </BoxSidebar>
          <BoxContent className="automation-rules__content">
            <div className="automation-rules__content-data">
              {activeKind === 'follow_ups' && !isEmpty && (
                <FollowUps
                  className="automation-rules__follow-ups"
                  followUps={
                    records as Record<
                      FollowUpStateType,
                      FollowUpModel<QqFollowUpModel>[]
                    >
                  }
                />
              )}
              {activeKind === 'lead_assignments' && !!lcService && (
                <LeadAssignments
                  leadAssignments={records as LeadAssignment[]}
                />
              )}
              {activeKind === 'business_hours' && <BusinessHours />}

              {activeKind === 'system_messages' && <SystemMessages />}
            </div>
          </BoxContent>
        </Box>
      </section>
    </>
  );
};
